<template>
  <div class="container-store">
    <StoreHeader/>
    <div style="width: 100%; margin-top: 20px; padding: 10px;" class="tabs is-centered is-boxed is-medium">
      <ul style="width: 100%">
        <li v-for="(t, idx) in tabsTitle" :key="idx" style="width: 30%;" :class="{'is-active': tabs===idx}" v-if="idx!=2||(idx==2&&user.isAgent&&user.isStoreOther)">
          <a @click="tabs=idx">
            <span>{{t}}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="main-box">
      <StoreView
        v-for="(s, i) in storeCategory" :key="i"
        :title="s.category_title" :subtitle="s.category_desc" :category="s.category_id" v-if="tabs==s.category_type"/>
      <StoreView :title="other.title" :subtitle="other.subtitle" :category="-1" v-if="tabs==2"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StoreHeader  from '@/views/Store/StoreHeader'
import StoreView    from '@/views/Store/StoreView'
export default {
  name: 'Store',
  componentName: 'Store',
  components: {
    StoreHeader,
    StoreView,
  },
  computed: {
    ...mapState('auth', ['user', 'storeCategory']),
  },
  mounted () {
    this.$store.dispatch('chatbot/getChatBotStoreItem')
    this.$store.dispatch('chatbot/getChatBotStoreHistory')
    this.$store.dispatch('chatbot/getChatBotStoreRate')
    this.$store.dispatch('auth/getStoreCateogry')
    this.$store.dispatch('chatbot/getChatBots')
  },
  data () {
    return {
      tabsTitle: ['ホームページ設置用', '応募後対応', '未分類'],
      other: {
        title: 'その他',
        subtitle: 'どのカテゴリにも属さない、ユニークなロボです',
        category: 'その他',
      },
      tabs: 0
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.container-store {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.tab-header {
  width: 100%;
  border: none;
  overflow-x: scroll;
}
.main-box {
  height: calc(100vh - 50px);
  width: 100%;
  overflow-y: scroll;
}
.main-box::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/Store.vue